import * as React from "react"
import { useRef, useEffect } from "react"
import { $desktop, $tablet } from "../../utils/breakpoints"

// Styles
import "./_testimonial-banner.scss"

// Components
import { Section, Container } from "../StyledComponents/layoutComponentStyles"

// Animations
import { createTriggerRevealTitle, createTriggerSlideText, triggerFadeIn } from "../../animations/globalAnims"
import { quoteAnim } from "../../animations/pages/workAnim"

interface QuoteBannerProps {
  module: any
}

/*









*/

const QuoteBanner: React.FunctionComponent<QuoteBannerProps> = ({ module }) => {
  // Refs
  const quoteRef = useRef<HTMLHeadingElement>(null)
  const nameRef = useRef<HTMLHeadingElement>(null)
  const compRef = useRef<HTMLParagraphElement>(null)

  // Effects
  useEffect(() => {
    if ($desktop) {
      createTriggerSlideText(quoteRef.current, 0.3)
      createTriggerRevealTitle(nameRef.current)
      triggerFadeIn(compRef.current, 0.3)
    } else if ($tablet) {
      quoteAnim(quoteRef.current, nameRef.current, compRef.current)
    }
  }, [])

  return (
    <Section>
      <Container fourteenClm>
        <div className='o-break-banner -quote'>
          <div className='o-break-banner__par'>
            <h5 ref={quoteRef}>{module.testimonialQuote}</h5>
          </div>
          <div className='o-break-banner__sml-clm'>
            <div>
              <h6 ref={nameRef}>{module.testimonialName}</h6>
              <p ref={compRef}>{module.testimonialCompany}</p>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default QuoteBanner
